export const url_route  = process.env.MIX_APP_FOLDERS;
export const url_api    = process.env.MIX_APP_FOLDERS + '/api';

export const selector   = 'selectedTr';

export let today    = new Date();
export let mm       = today.getMonth() + 1;
export let dd       = today.getDate();
export let yyyy     = today.getFullYear();

